<template lang="pug">
#app(:class="_isMobile() ? '' : 'minwidthApp'")
  event-header-nav(
    v-if="!(_isMobile() || $route.name === 'AppIndex' || !isLogged)"
  )
  .content
    router-view
  compare-utils
</template>

<script>
import EventHeaderNav from './components/EventHeaderNav'
import MaintenanceAnnouncement from './components/MaintenanceAnnouncement'
import CompareUtils from './components/CompareUtils'
export default {
  name: 'App',
  created () { },
  computed: {
    isLogged () {
      return this.$store.getters.logged
    }
  },
  mounted () {
    let CNZZ_ID = 1277663022
    const script = document.createElement('script')
    script.src = `https://s95.cnzz.com/z_stat.php?id=${CNZZ_ID}&web_id=${CNZZ_ID}`
    script.language = 'JavaScript'
    document.body.appendChild(script)
    // function adjust () {
    //   let deviceWidth = document.documentElement.clientWidth
    //   document.documentElement.style.fontSize = '12px'
    //   if (deviceWidth >= 1440) {
    document.documentElement.style.fontSize = '14px'
    //   }
    // }
    // adjust()
    // window.addEventListener('resize', e => {
    //   adjust()
    // })
    if (this._isMobile()) {
      // alert('移动端暂无法访问，请使用PC端浏览器访问')
      console.log(this.$route)
      if (this.$route.name === 'WeixinReport') {
        // this.$router.replace({ name: 'WeixinReport' })
        return
      }
      this.$router.replace({ name: 'AppIndex' })
    }
    // function preload () {
    //   let imgs = [
    //     require('@static/img/8th_anniversary_poster.png')
    //   ]
    //   for (let img of imgs) {
    //     let image = new Image()
    //     image.src = img
    //   }
    // }
    // preload()
  },
  watch: {
    $route: {
      handler (to, from) {
        // console.log(to, from)
        setTimeout(() => {
          // 避免首次获取不到window._czc
          if (window._czc) {
            let location = window.location
            let contentUrl = location.pathname + location.hash
            let refererUrl = '/'
            // 用于发送某个URL的PV统计请求，
            window._czc.push(['_setAutoPageview', false])
            window._czc.push(['_trackEvent', contentUrl, refererUrl])
          }
        }, 300)
      },
      immediate: true
    }
  },
  methods: {
    _isMobile () {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      )
      return flag
    }
  },
  components: {
    CompareUtils,
    EventHeaderNav,
    MaintenanceAnnouncement
  }
}
</script>

<style lang="scss">
@import "~normalize.scss/normalize.scss";
$fa-font-path: "~font-awesome/fonts";
@import "~font-awesome/scss/font-awesome.scss";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Microsoft YaHei";
}

ul {
  list-style: none;
}

a {
  text-decoration: none;
  color: #666;
  cursor: pointer;

  &:hover {
    color: #3989cb;
  }
}

html {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

body {
  width: 100%;
  height: 100%;
  overflow: auto;
}

button {
  outline: none;
  border: none;
}

#app {
  width: 100%;
  height: 100%;
  overflow: auto;
  display: flex;
  flex-flow: column nowrap;

  .layout_screen_width {
    padding-left: 10px;
    padding-right: 10px;

    @media screen and (min-width: 1760px) {
      margin: 0 auto;
      width: 1760px !important;
    }

    @media screen and (min-width: 1920px) {
      width: auto !important;
      padding-left: 80px;
      padding-right: 80px;
    }
  }
}

.minwidthApp {
  min-width: 1366px;
  overflow: auto;
}

.content {
  position: relative;
  flex: 1;
  overflow: hidden;
  /*background: radial-gradient(closest-corner  circle at 50% 95%, rgba(255,255,255,0.2), rgba(0,0,0,0));*/
}

.error {
  color: #f00;
  margin-bottom: 10px;
}

::-webkit-scrollbar-track {
  // -webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);
  background-color: transparent;
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: #3989cb;
}

/*::-webkit-scrollbar-track {*/
/*  !*-webkit-box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.3);*!*/
/*  background-color: #fafafa;*/
/*}*/
/*::-webkit-scrollbar {*/
/*  width: 5px;*/
/*  background-color: #fafafa;*/
/*}*/
/*::-webkit-scrollbar-thumb {*/
/*  background-color: #eeeeee;*/
/*}*/
/*element样式统一修改*/
.is-checked .el-checkbox__inner {
  background-color: #3989cb !important;
  border-color: #3989cb !important;
}

table {
  mso-cellspacing: 0;
  mso-cellspacing: 0;
}

i.fa {
  cursor: pointer;
}

tr td {
  i.fa-star {
    color: #f87653;
  }

  i.fa-star-o {
    color: #ccc;
  }
}

// el-tooltip
.el-tooltip__popper {
  box-shadow: 2px 3px 3px 0 rgba(6, 0, 1, 0.1) !important;
  border: solid 1px #e6eaef !important;
}

.popper__arrow {
  border-top-color: #e6eaef !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/App.vue